<template>
  <main class="container">
    <div class="row">
      <div class="col">
        <div class="card p-0 alert alert-secondary" role="article">
          <div class="card-header">
            <h1 class="my-auto fs-3 fw-bold text-start">
              Image Selection Gallery
            </h1>
          </div>
          <div class="card-body">
            <div
              class="alert alert-light shadow-sm mb-4 p-0"
              v-for="(image, i) in images"
              :key="i"
              style="min-height: 350px"
            >
              <div class="row g-0 h-100 flex-md-row flex-column">
                <!-- Left: Image -->
                <div class="col-md-6 col-12 d-flex align-items-stretch">
                  <img
                    class="img-fluid h-100 w-100 object-fit-cover rounded-start border border-2"
                    :src="imgSrc(image.src)"
                    :alt="`${image.name} thumbnail`"
                    style="min-height: 200px"
                  />
                </div>
                <!-- Right: Content -->
                <div class="col-md-6 col-12 d-flex flex-column p-3">
                  <div>
                    <div class="alert alert-secondary py-2 w-100 mb-3">
                      <h2 class="fs-4 fw-bold my-auto mb-0 text-start">
                        {{ image.name }}
                      </h2>
                    </div>
                    <div class="px-1 text-start mb-3">
                      <ul v-if="image.description[0] != ''" class="mb-0">
                        <li
                          v-for="(item, i) in image.description"
                          :key="i"
                          v-html="item"
                        ></li>
                      </ul>
                    </div>
                  </div>
                  <div class="mt-auto">
                    <RouterLink
                      :to="{ name: 'MarkupView' }"
                      class="btn btn-primary btn-lg fw-bold w-100"
                      @click="setActiveImageIndex(i)"
                      >Markup Image <span class="bi-arrow-right"></span
                    ></RouterLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ImageSelectionView",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ images: "getImages" })
  },
  created() {},
  methods: {
    ...mapActions({
      setActiveImageIndex: "setActiveImageIndex"
    }),
    imgSrc(src) {
      return require(`@/assets/${src}`);
    }
  }
};
</script>
